// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__UPc8x","btnText":"Button_btnText__BZ9Hh"};